import React, { useMemo } from "react";
import { Card, CardBody, CardHeader } from "reactstrap";
import TableContainer from "../../../../Components/Common/TableContainer";

const PaymentMethodChart = ({ paymentSummary = {} }) => {
  const paymentData = [
    {
      method: "Cash",
      amount: paymentSummary.cash || 0,
      badge: "Cash",
    },
    {
      method: "Card",
      amount: paymentSummary.card || 0,
      badge: "Card",
    },
    {
      method: "UPI",
      amount: paymentSummary.upi || 0,
      badge: "UPI",
    },
    {
      method: "Bank",
      amount: paymentSummary.bank || 0,
      badge: "Bank",
    },
  ];

  const renderBadge = (type) => {
    switch (type) {
      case "Cash":
        return (
          <span className="badge bg-success-subtle text-success text-uppercase">
            Cash
          </span>
        );

      case "Card":
        return (
          <span className="badge bg-primary-subtle text-primary text-uppercase">
            Card
          </span>
        );

      case "UPI":
        return (
          <span className="badge bg-warning-subtle text-warning text-uppercase">
            UPI
          </span>
        );

      case "Bank":
        return (
          <span className="badge bg-info-subtle text-info text-uppercase">
            Bank
          </span>
        );

      default:
        return (
          <span className="badge bg-light text-dark">
            {type}
          </span>
        );
    }
  };

  const columns = useMemo(
    () => [
      {
        header: "Payment Method",
        accessorKey: "method",
      },
      {
        header: "Type",
        accessorKey: "badge",
        cell: ({ getValue }) => renderBadge(getValue()),
      },
      {
        header: "Amount",
        accessorKey: "amount",
        cell: ({ getValue }) =>
          `₹${Number(getValue()).toLocaleString()}`,
      },
    ],
    []
  );

  return (
    <Card style={{ height: "430px" }}>
      <CardHeader>
        <h4 className="card-title mb-0">
          Payment Methods
        </h4>
      </CardHeader>

      <CardBody>
        <TableContainer
          columns={columns}
          data={paymentData}
          customPageSize={5}
          className="text-nowrap"
          theadClass="bg-light"
        />
      </CardBody>
    </Card>
  );
};

export default PaymentMethodChart;